import { createDefaultTrigger } from '../../services/automationRegistry'
import type {
  AutomationAction,
  AutomationCondition,
  AutomationConstraint,
  AutomationGraph,
  AutomationTrigger,
} from '../../types/automation'

export type GraphDraft = {
  id: string | null
  name: string
  description: string
  triggers: AutomationTrigger[]
  constraint?: AutomationConstraint
  if?: AutomationCondition
  then: AutomationAction[]
  else?: AutomationAction[]
}

export const makeEmptyGraphDraft = (): GraphDraft => ({
  id: null,
  name: 'Untitled automation',
  description: '',
  triggers: [createDefaultTrigger('NODE_CREATED')],
  constraint: undefined,
  if: undefined,
  then: [],
  else: undefined,
})

export const graphToDraft = (graph: AutomationGraph): GraphDraft => ({
  id: graph.id,
  name: graph.name,
  description: graph.description ?? '',
  triggers: graph.triggers,
  constraint: graph.constraint,
  if: graph.if,
  then: graph.then,
  else: graph.else,
})
